/**
 * Stable CSS class names for E2E / automation on Cargo Address Blocking.
 * Combine layout sections with `cargo-address-blocking-input--{kind}` on interactive controls.
 */
export const CAB = {
    page: 'cargo-address-blocking-page',
    paper: 'cargo-address-blocking-page__paper',
    toolbar: 'cargo-address-blocking-page__toolbar',
    bulkActions: 'cargo-address-blocking-page__bulk-actions',
    datagrid: 'cargo-address-blocking-page__datagrid',
    emptyState: 'cargo-address-blocking-page__empty-state',

    drawer: 'cargo-address-blocking-drawer',
    drawerSearch: 'cargo-address-blocking-drawer--search',
    drawerAdd: 'cargo-address-blocking-drawer--add',
    drawerBody: 'cargo-address-blocking-drawer__body',
    drawerForm: 'cargo-address-blocking-drawer__form',
    drawerActions: 'cargo-address-blocking-drawer__actions',

    input: 'cargo-address-blocking-input',
    inputButton: 'cargo-address-blocking-input--button',
    inputCheckbox: 'cargo-address-blocking-input--checkbox',
    inputAutocomplete: 'cargo-address-blocking-input--autocomplete',
    inputTextfield: 'cargo-address-blocking-input--textfield',
    fieldCargoCompany: 'cargo-address-blocking-field--cargo-company',
    fieldCity: 'cargo-address-blocking-field--city',
    fieldCounty: 'cargo-address-blocking-field--county',
    fieldNeighborhood: 'cargo-address-blocking-field--neighborhood',

    btnAddNew: 'cargo-address-blocking-field--add-new',
    btnExportExcel: 'cargo-address-blocking-field--export-excel',
    btnOpenSearch: 'cargo-address-blocking-field--open-search',
    btnBulkDelete: 'cargo-address-blocking-field--bulk-delete',
    btnDeleteRow: 'cargo-address-blocking-field--delete-row',
    btnEmptySearch: 'cargo-address-blocking-field--empty-search',

    btnDrawerClear: 'cargo-address-blocking-field--drawer-clear',
    btnDrawerSubmit: 'cargo-address-blocking-field--drawer-submit',

    cbCountyOption: 'cargo-address-blocking-field--county-option-checkbox',
    cbNeighborhoodOption: 'cargo-address-blocking-field--neighborhood-option-checkbox',
    /** Row / header selection checkboxes on the results grid */
    cbGridSelection: 'cargo-address-blocking-field--grid-selection-checkbox',
} as const;

export const cabCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
